import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface EqualizerConfig {
  /** dB, -15..+15 — grave (150Hz, plateau). */
  lowDb: number;
  /** dB, -15..+15 — médium (1kHz, cloche). */
  midDb: number;
  /** dB, -15..+15 — aigu (4kHz, plateau). */
  highDb: number;
}

class EqualizerEffectImpl extends AudioEffect<EqualizerConfig> {
  readonly id = 'equalizer';
  readonly label = 'Égaliseur';
  readonly icon = SlidersHorizontal;
  readonly description = 'Égaliseur 3 bandes — grave / médium / aigu, en série sur le signal';
  readonly defaultConfig: EqualizerConfig = { lowDb: 0, midDb: 0, highDb: 0 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: EqualizerConfig): void {
    registry.setEqualizer(regId, enabled, config.lowDb, config.midDb, config.highDb);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<EqualizerConfig>) {
    const fmt = (v: number) => `${v > 0 ? '+' : ''}${v.toFixed(1)} dB`;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <LevelSlider
          label="Grave" value={config.lowDb}
          min={-15} max={15} defaultValue={0} roundTo={0.5}
          format={fmt}
          onChange={lowDb => onChange({ ...config, lowDb })}
        />
        <LevelSlider
          label="Médium" value={config.midDb}
          min={-15} max={15} defaultValue={0} roundTo={0.5}
          format={fmt}
          onChange={midDb => onChange({ ...config, midDb })}
        />
        <LevelSlider
          label="Aigu" value={config.highDb}
          min={-15} max={15} defaultValue={0} roundTo={0.5}
          format={fmt}
          onChange={highDb => onChange({ ...config, highDb })}
        />
      </div>
    );
  }
}

export const equalizerEffect = new EqualizerEffectImpl();
